import { create } from "zustand";
import { devtools, persist } from "zustand/middleware";

const useAccountFormStore = create(
    devtools(
        persist(
            (set, get) => ({
                accounts: [],
                addAccount: (account) => set((state) => ({ ...state, accounts: [{ ...account, updatedAt: new Date().toISOString() }, ...state.accounts] })),
                getAccountByAccountId: (accountId) => get().accounts.find((a) => a.accountId === accountId),
                upsertAccount: (updatedAccount) =>
                    set((state) => {
                        const updatedAt = new Date().toISOString();
                        const accounts = state.accounts?.some((a) => a.accountId === updatedAccount.accountId)
                            ? state.accounts.map((existingAccount) => {
                                if (existingAccount.accountId === updatedAccount.accountId) {
                                    existingAccount = { ...existingAccount, ...updatedAccount, updatedAt };
                                }
                                return existingAccount;
                            })
                            : [...state.accounts, updatedAccount];


                        return {
                            ...state,
                            updatedAt,
                            accounts,
                        }
                    }),
                removeAccountByAccountId: (accountId) => set((state) => ({ ...state, accounts: state.accounts.filter((a) => a.accountId !== accountId) })),
                removeAllAccounts: () => set((state) => ({ ...state, accounts: [] }))
            }),
            {
                name: "account-form-storage",
            }
        )
    )
);

export { useAccountFormStore };
